import React from 'react';
import { connect } from 'react-redux';

import { show526Wizard } from 'applications/disability-benefits/all-claims/utils';
import { getStartUrl } from 'applications/disability-benefits/all-claims/utils/startFlow';

/*
 * Showing the wizard on the Intro page, so when set, this shows the link
 * on the hub page; this file & the `createWizard` files won't be neccessary
 * once we get the flipper to 100% and the Drupal page includes a direct link to
 * the introduction page
 */
const WizardLink = ({ showWizard, startUrl, module }) => {
  const { Wizard, pages } = module.default;
  return showWizard ? (
    <a href={startUrl} className="vads-c-action-link--green">
      Let’s get started
    </a>
  ) : (
    <Wizard pages={pages} expander buttonText="Let’s get started" />
  );
};

const mapStateToProps = state => ({
  showWizard: show526Wizard(state),
  startUrl: getStartUrl(state),
});

export default connect(mapStateToProps)(WizardLink);
